import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Tooltip from '../../../../../../common/components/Tooltip';

export const NoReleaseNotesMessage = 'Release Notes are not available.';

function ReleaseNotesTooltip({ name, list, ...rest }) {
  const titleText = useMemo(() => {
    const fw = list.find((fw) => fw.firmwareVersionName === name);

    return get(fw, 'releaseNotes') || NoReleaseNotesMessage;
  }, [name, list]);

  if (!name) return null;

  return (
    <Tooltip
      title={
        <Typography>
          <strong>Release Notes:</strong>
          <br />
          {titleText}
        </Typography>
      }
      {...rest}
    >
      <InfoOutlinedIcon fontSize="small" />
    </Tooltip>
  );
}

ReleaseNotesTooltip.defaultProps = {
  name: null,
  list: [],
  placement: 'bottom-start',
};

ReleaseNotesTooltip.propTypes = {
  name: PropTypes.string,
  list: PropTypes.array,
};

export default ReleaseNotesTooltip;
